/**
 * @note
 * THIS WILL BE DEPRECATED.
 *
 * When the components inside of `hatch-web-client` are removed in favor of
 * the implementation in `@usehatchapp/components`, we should be able to remove this function
 * because it is used in the following components at the time of writing:
 * 1. src/components/molecules/Avatar/styles.js
 * 2. src/components/molecules/BoardsAvatar/styles.js
 *
 * BEFORE REMOVING, CHECK CODEBASE FOR CONSUMPTION OF THIS FUNCTION!
 */

export type GenerateColorReturnType = {
  color: string;
  isDark: boolean;
};

// Takes an ID (e.g. '00000017') and array of hex values (e.g. ['#000', '#fff'])
// and returns an object with a hex value and an isDark boolean for that color
export const generateColor = (
  id = '00000001',
  colorsArr = ['#fff'],
): GenerateColorReturnType => {
  try {
    // Make sure the input is what we expect
    if (
      typeof id !== 'string' ||
      !Array.isArray(colorsArr) ||
      !colorsArr.length
    ) {
      return {
        color: '#fff',
        isDark: false,
      };
    }

    // convert the ID into an integer
    const summedId = id.split('').reduce((acc, cur) => {
      return acc + parseInt(cur, 10) || 0;
    }, 0);

    // pull the hex value off the passed array by calculating the modulus
    const hex = colorsArr[summedId % colorsArr.length];

    // convert hex to RGB so we can determine if it is light or dark
    const rgb = hex
      .replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`,
      )
      .substring(1)
      .match(/.{2}/g)
      .map((x) => parseInt(x, 16));
    const isDark = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000 < 141;

    return {
      color: hex,
      isDark,
    };
  } catch (err) {
    return {
      color: colorsArr[0],
      isDark: false,
    };
  }
};
